export default "__VITE_ASSET__BWasnq3Q__"